"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getDexie = getDexie;
exports.initializeDexie = initializeDexie;
exports.generalConfigFallback = void 0;

var _dexie = _interopRequireDefault(require("dexie"));

var _pounderThemes = _interopRequireDefault(require("../pounder-themes"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var db = null;
var isSetup = false;
var storeName = 'pounder-config';

function getDexie() {
  if (!isSetup) {
    throw "Dexie isn't Initialized, ensure you call initializeDexie() first";
  } else {
    return db;
  }
}

function initializeDexie() {
  db = new _dexie["default"](storeName);
  db.version(1).stores({
    cssConfig: "id, propertyName, value",
    generalConfig: "id, value"
  });
  db.version(2).stores({
    muiThemes: 'id'
  }).upgrade(function (tx) {
    setBuiltInThemes(tx);
  });
  db.version(3).stores({
    lastUndoAction: 'id'
  });
  db.on("populate", function () {
    db.generalConfig.put({
      id: 0,
      value: {
        isFirstTimeBoot: true,
        appVersion: HANDBALL_VERSION
      }
    });
    setBuiltInThemes(db);
  });
  isSetup = true;
}

function setBuiltInThemes(db) {
  db.muiThemes.bulkPut(_pounderThemes["default"]).then(function () {});
} // Fallback Values.


var generalConfigFallback = {
  startInFullscreen: false,
  startLocked: false,
  selectedMuiThemeId: 'default'
};
exports.generalConfigFallback = generalConfigFallback;



//////////////////
// WEBPACK FOOTER
// ../handball-libs/libs/pounder-dexie/index.js
// module id = 702
// module chunks = 0